import { CustomerSkeleton } from "../../../shared/CustomerContentPatterns";
import "./page-loading.css";

/**
 * While a page's code or first answer loads: the shape of a page, not a full-screen spinner
 * (Stage 2, D10). Its words are for screen readers; the shapes say it visually.
 */
export function PageLoading({ label = "Opening Life’s Capsule…" }: { label?: string }) {
  return (
    <main id="main-content" className="page-loading" aria-busy="true">
      <p className="sr-only" role="status" aria-live="polite">
        {label}
      </p>
      <span className="page-loading__title" aria-hidden="true" />
      <span className="page-loading__line" aria-hidden="true" />
      <CustomerSkeleton lines={4} />
    </main>
  );
}
